import { create } from "zustand";
import { getAovApi, getConversionApi, getSessionApi } from "../api/api";

const useConversionStore = create((set) => ({
  sessionData: {},
  aovData:{},
  converionData:{},
  sessionLoading: false,
  aovLoading:false,
  conversionLoading:false,
  error: null,
  getSessionData: async (startDate, endDate, compStartDate, compEndDate) => {
    try {
      set({ sessionLoading: true, error: null });
      const response = await getSessionApi(startDate, endDate, compStartDate, compEndDate);
      set({ sessionData: response.data, sessionLoading: false });
    } catch (error) {
      set({ error: error.message, sessionLoading: false });
    }
  },
  getAovData: async (startDate, endDate, compStartDate, compEndDate) => {
    try {
      set({ aovLoading: true, error: null });
      const response = await getAovApi(startDate, endDate, compStartDate, compEndDate);
      set({ aovData: response.data, aovLoading: false });
    } catch (error) {
      set({ error: error.message, aovLoading: false });
    }
  },
  getConversionData: async (startDate, endDate, compStartDate, compEndDate) => {
    try {
      set({ conversionLoading: true, error: null });
      const response = await getConversionApi(startDate, endDate, compStartDate, compEndDate);
      set({ converionData: response.data, conversionLoading: false });
    } catch (error) {
      set({ error: error.message, conversionLoading: false });
    }
  },
}));

export default useConversionStore;